import React, { Component } from "react";
import { Form } from "antd";
import { connect } from "react-redux";
import { compose } from "redux";
import { withFirestore, firestoreConnect } from "react-redux-firebase";

import Settings from "./Settings";
import { ShopifyFields as Fields } from "../common/labels/forms";
import { sendShopifyConfig, deleteShopify } from "../../actions/setting";

class index extends Component {
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.sendShopifyConfig(values);
      }
    });
    this.props.form.resetFields();
  };

  deleteShopify = () => {
    this.props.deleteShopify()
  }

  render() {
    return (
      <div>
        <Settings
          Fields={Fields}
          getFieldDecorator={this.props.form.getFieldDecorator}
          handleSubmit={this.handleSubmit}
          shopify={this.props.shopify}
          deleteShopify={this.deleteShopify}
        />
      </div>
    );
  }
}

const WrappedIndex = Form.create({ name: "shopify" })(index);

const mapToStateToProps = ({ firebase, firestore }) => {
  return {
    auth: firebase.auth,
    shopify: firestore.data
  };
};

const mapToDispatchToProps = (dispatch, ownProps) => {
  return {
    sendShopifyConfig: keys => dispatch(sendShopifyConfig(keys, ownProps)),
    deleteShopify: () => dispatch(deleteShopify(ownProps))
  };
};

export default compose(
  withFirestore,
  connect(
    mapToStateToProps,
    mapToDispatchToProps
  ),
  firestoreConnect(props => {
    return [
      {
        collection: "shopify",
        where: [["userId", "==", props.auth.uid || null]]
      }
    ];
  })
)(WrappedIndex);
